import { forwardRef, PropsWithoutRef } from 'react';
import { useDefaultFormContext } from './useDefaultFormValues';
import { ZeroInvoiceTotalForm } from './ZeroInvoiceTotalForm/ZeroInvoiceTotalForm';
import { ProcessPaymentType } from './ProcessPaymentType';
import { GatewayPaymentForm } from './GatewayPaymentForm/GatewayPaymentForm';
import { MewsTerminalPaymentForm } from './MewsTerminalPayment/MewsTerminalPaymentForm';
import { PaymentRequestForm } from './PaymentRequestForm/PaymentRequestForm';
import { ExternalCardPaymentForm } from './ExternalCardPaymentForm/ExternalCardPaymentForm';
import { CashPaymentForm } from './CashPaymentForm/CashPaymentForm';
import { ExternalPaymentForm } from './ExternalPaymentForm/ExternalPaymentForm';
import { TokenizeCardForm } from './TokenizeCardForm/TokenizeCardForm';
import { RecordCardForm } from './RecordCardForm/RecordCardForm';
import { GatewayPreauthorizationForm } from './GatewayPreauthorizationForm/GatewayPreauthorizationForm';
import { ExternalPreauthorizationForm } from './ExternalPreauthorizationForm/ExternalPreauthorizationForm';
import { MewsTerminalPreauthorizationForm } from './MewsTerminalPreauthorizationForm/MewsTerminalPreauthorizationForm';
import { PaymentFormProps } from './types';

const paymentDialog = {
    [ProcessPaymentType.GatewayPayment]: GatewayPaymentForm,
    [ProcessPaymentType.MewsTerminalPayment]: MewsTerminalPaymentForm,
    [ProcessPaymentType.PaymentRequest]: PaymentRequestForm,
    [ProcessPaymentType.ExternalCardPayment]: ExternalCardPaymentForm,
    [ProcessPaymentType.CashPayment]: CashPaymentForm,
    [ProcessPaymentType.ExternalPayment]: ExternalPaymentForm,
    [ProcessPaymentType.TokenizeCard]: TokenizeCardForm,
    [ProcessPaymentType.RecordCard]: RecordCardForm,
    [ProcessPaymentType.GatewayCardPreauth]: GatewayPreauthorizationForm,
    [ProcessPaymentType.ExternalCardPreauth]: ExternalPreauthorizationForm,
    [ProcessPaymentType.MewsTerminalPreauth]: MewsTerminalPreauthorizationForm,
};

type Props = PaymentFormProps & {
    paymentType: ProcessPaymentType;
};

export const FormComponent = forwardRef(({ paymentType, ...formProps }: PropsWithoutRef<Props>, ref) => {
    const { invoiceTotal } = useDefaultFormContext();

    const PaymentForm = invoiceTotal === 0 ? ZeroInvoiceTotalForm : paymentDialog[paymentType];

    if (PaymentForm == null) return null;

    return <PaymentForm {...formProps} ref={ref} />;
});
